import { createReducer } from "utils/redux";

export const ADMIN_ACTION_SUCCESS = 'ADMIN_ACTION_SUCCESS';
export const ADMIN_ACTION_FAILED = 'ADMIN_ACTION_FAILED';

export const AdminActionResult = createReducer(
    ADMIN_ACTION_SUCCESS,
    ADMIN_ACTION_FAILED
);